import { Route, Navigate } from "react-router-dom";

import Home from "../pages/public/Home";
import About from "../pages/public/About";
import Contact from "../pages/public/Contact";
import Privacy from "../pages/public/Privacy";
import Terms from "../pages/public/Terms";
import Support from "../pages/public/Support";

import LoginPage from "../pages/auth/LoginPage";
import SignupPage from "../pages/auth/SignupPage";
import ForgotPasswordPage from "../pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import Plans from "../pages/public/Plan";
import Templates from "../pages/public/Templates";
import { getUser } from "../api/auth";

function RootHandler() {
  let user = null;
  try {
    user = getUser();
  } catch {
    user = null;
  }

  if (user) {
    // Redirect based on role (adjust role values to match your system)
    if (user.role === "admin") {
      return <Navigate to="/admin" replace />;
    } else if (user.role === "organization") {
      return <Navigate to="/organization" replace />;
    } else {
      // default to user dashboard
      return <Navigate to="/user" replace />;
    }
  }

  // Not logged in: show Home page
  return <Home />;
}

export default function PublicRoutes() {
  return (
    <>
      <Route path="/" element={<RootHandler />} />

      <Route path="/about" element={<About />} />

      <Route path="/contact" element={<Contact />} />

      <Route path="/support" element={<Support />} />

      <Route path="/privacy" element={<Privacy />} />

      <Route path="/terms" element={<Terms />} />

      <Route path="/sign-in" element={<LoginPage />} />

      <Route path="/plans" element={<Plans />} />

      <Route path="/sign-up" element={<SignupPage />} />

      <Route path="/templates" element={<Templates />} />

      <Route path="/forgot-password" element={<ForgotPasswordPage />} />

      <Route path="/reset-password/:token" element={<ResetPasswordPage />}
      />
    </>
  );
}